<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center">
        <div
          class="col-xl-6 col-lg-4 col-md-4 col-sm-12 col-6 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>

        <div
          class="col-xl-6 col-lg-8 col-md-8 col-sm-12 col-6 align-items-center text-right"
        >
          <div class="box-buttons">
            <div class="d-inline-block mr-1" v-if="service">
              <b-form-group v-slot="{ ariaDescribedbyview }">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="mode"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  class="mb-2"
                  button-variant="outline-neutral pc-4"
                >
                  <b-form-radio value="view"
                    ><i
                      class="flaticon-bold-menu mt-1"
                      title="Expanded View"
                    ></i
                  ></b-form-radio>
                  <b-form-radio value="list"
                    ><i class="flaticon-two mt-1" title="List View"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-plus"></i>
                <strong class="d-lg-block d-none">Add</strong>
              </base-button>
              <div
                class="dropdown-item"
                @click="
                  openExtrasModal(reservation.service, reservation.customer)
                "
              >
                <span class="icon-action"> Add Extras </span>
              </div>

              <div
                class="dropdown-item"
                @click="
                  openDiscountModal(reservation.service, reservation.customer)
                "
              >
                <span class="icon-action"> Add Discount </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view' || mode === 'list'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button ml-2 no-mb"
              @click="storeReservation()"
              v-if="mode === 'edit' && canUserCreate"
              :disabled="buttonDisabled"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
          v-if="reservation.childSeatsCount > 0"
        >
          <base-alert type="warning" class="mb-2 info-min">
            <i class="flaticon-warning mr-1"></i>
            <strong>Important!</strong>
            <ol class="pl-3 mb-0">
              <li>
                <span class="span-alert" v-if="mode === 'edit'">
                  <strong>You are adding a child seat(s).</strong> You must
                  verify with the supplier that the requested child seat(s) can
                  be fulfilled. Even if child seats have no additional cost,
                  they must be registered as extras in the system with a price
                  of 20 USD/EUR once the supplier has confirmed availability. If
                  any additional costs apply, add the extra to the reservation
                  and contact the customer to process the payment. After adding
                  the extra, send a notification to the customer confirming the
                  update.
                </span>
                <span class="span-alert" v-else>
                  <strong>
                    You must This reservation includes child seat(s).
                  </strong>
                  Please ensure that the availability has been confirmed with
                  the supplier and that the child seat(s) have been correctly
                  added as extras. Child seats must appear as extras in the
                  charges. If any additional charges apply, the customer should
                  have been contacted and notified accordingly.
                </span>
              </li>
            </ol>
          </base-alert>
        </div>

        <div v-show="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{ getTitleByGender(passenger.gender) }}
                                {{ passenger.fullName }}</span
                              >

                              <span class="date-time">
                                {{ getFormatDate(reservation.pickup_date) }}
                                at
                                {{ getFormatTime(reservation.pickup_time) }}
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center"
                            >
                              <span class="label-total"> TOTAL CHARGES: </span>

                              <span
                                class="price-total"
                                :class="
                                  reservation.pricing.totals.gross_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  parsePrice(
                                    reservation.pricing.totals.gross_price
                                  )
                                }}
                                {{ currency.code }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      >
                        <div class="card-ticket">
                          <div class="box">
                            <div class="row">
                              <div class="col-12 p-0">
                                <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                  <div class="address-content">
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-start text-primary"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one"
                                        >Pickup:
                                        {{
                                          getFormatTime(reservation.pickup_time)
                                        }}
                                      </span>
                                      <span class="title-two">{{
                                        reservation.from
                                      }}</span>
                                    </div>
                                  </div>

                                  <div
                                    class="address-content mt-2"
                                    v-if="reservation.type !== 'hourly'"
                                  >
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-placeholder-1 text-success"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one">Dropoff </span>
                                      <span class="title-two">{{
                                        reservation.to
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="box box-services">
                            <div class="row" v-if="service !== null">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-serv-v card-select">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <img
                                      v-lazy="service.vehicle.image"
                                      class="img-fluid es-img-service"
                                      alt="Service Car"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-12 align-self-center alinmov4 pl-sm-0 pr-0"
                                  >
                                    <h2 class="title-serv">
                                      {{
                                        formatServiceCategory(
                                          service.vehicle.category
                                        )
                                      }}

                                      {{ service.vehicle.seats }} seats
                                    </h2>

                                    <span class="type-card"
                                      >{{ service.vehicle.make_label }} or
                                      Similar</span
                                    >

                                    <div class="descrip">
                                      <span>
                                        <i class="flaticon-people-1"></i>
                                        PAX: {{ service.vehicle.seats }}
                                      </span>

                                      <span>
                                        <i class="flaticon-briefcase"></i>
                                        Bags: {{ service.vehicle.suitcases }}
                                      </span>
                                    </div>

                                    <div class="more-details">
                                      <ul class="mb-0">
                                        <li
                                          v-for="tag in service.vehicle.tags || []"
                                          :key="tag.ref"
                                        >
                                          {{ tag.name }}
                                        </li>
                                        <li v-if="service.preference.wifi">
                                          WiFi onboard
                                        </li>
                                        <li v-if="service.preference.water">
                                          Water
                                        </li>
                                        <li
                                          v-if="
                                            service.preference.hand_sanitizer
                                          "
                                        >
                                          Hand Sanitizer
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 supplier-box"
                          >
                            <div class="item-content-2" v-if="service">
                              <label>Destination: </label
                              ><span class="ml-1">
                                {{ getBranchName(service.branchId) }}
                              </span>
                              <span class="mx-2 no-mobile-xxs">|</span>
                            </div>

                            <div class="item-content-2" v-if="service">
                              <label>Supplier: </label>
                              <span class="ml-1">
                                <a
                                  :href="`/suppliers/${reservation.supplier}`"
                                  target="_blank"
                                >
                                  {{ getSupplierName(service.supplierId) }}
                                </a>
                                <el-popover
                                  placement="bottom"
                                  trigger="hover"
                                  width="300"
                                  class="curp d-inline-flex ml-1"
                                  v-if="getSupplierNotes(service.supplierId)"
                                >
                                  <span>
                                    <strong>Notes: </strong>
                                    <span class="text-min">
                                      {{ getSupplierNotes(service.supplierId) }}
                                    </span>
                                  </span>

                                  <div
                                    slot="reference"
                                    class="badge badge-note"
                                  >
                                    Note
                                  </div>
                                </el-popover></span
                              >
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Type Transfer</span>
                                  <span class="content-block">
                                    {{ formatTransferType(reservation.type) }}
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="reservation.type !== 'journey'"
                              >
                                <div class="data-block">
                                  <span class="title-block">
                                    {{
                                      formatTransportTypeLabel(reservation.type)
                                    }}
                                  </span>
                                  <TransportReference
                                    content-class="content-block"
                                    :reservation="reservation"
                                    :loading="loaderVerifyFlight"
                                    @track="getFlightsInformationByIdent"
                                  />
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX N°</span>
                                  <span class="content-block"
                                    >{{ reservation.passengersCount }} PAX</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">
                                    {{ getTitleByGender(passenger.gender) }}
                                    {{ passenger.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX Phone</span>
                                  <span class="content-block"
                                    >{{ passenger.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="passenger.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block mb-0">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/${customer._id}`
                                          : `/customers/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        formatClientType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Pickup Sign</span>
                                  <div v-if="pdfDataUrl" class="content-block">
                                    <span
                                      class="link ml-0"
                                      @click="openPreviewPickup()"
                                    >
                                      <i class="flaticon-visualization mr-1"></i
                                      >File uploaded</span
                                    >
                                  </div>

                                  <div v-else>
                                    <span
                                      class="content-block"
                                      v-if="reservation.pickupSign.text"
                                      >{{ reservation.pickupSign.text }}</span
                                    >

                                    <span class="content-block" v-else
                                      >NONE</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <FadeTransition
                            :duration="300"
                            mode="out-in"
                            v-show="reservation.passengers.length"
                          >
                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2"
                              v-if="reservation.passengers.length > 1"
                            >
                              <div class="card">
                                <div class="data-block mb-2">
                                  <span class="title-block f-14">PAX</span>
                                </div>
                                <b-table
                                  hover
                                  :items="reservation.passengers"
                                  :fields="
                                    getHeaderPassengerTable(
                                      fieldsPassengerView,
                                      reservation.type
                                    )
                                  "
                                  sort-by.sync="fullname"
                                  sort-desc.sync="true"
                                  select-mode="single"
                                  ref="tableviewpassengers"
                                  sort-icon-left
                                  responsive
                                  show-empty
                                  empty-filtered-text="There are no records matching your request"
                                  empty-text="There are no records to show"
                                >
                                  <template #cell(fullname)="data">
                                    <span class="text-capitalize"
                                      >{{ getTitleByGender(data.item.gender) }}
                                      {{ data.item.firstName }}
                                      {{ data.item.lastName }}
                                    </span>

                                    <span
                                      class="badge-status badge-default mr-2"
                                      v-if="data.item.primary"
                                      >Primary</span
                                    >
                                  </template>

                                  <template #cell(phone)="data">
                                    <span v-if="data.item.phone">{{
                                      data.item.phone
                                    }}</span>
                                    <span v-else>N/A</span>
                                  </template>

                                  <template #cell(email)="data">
                                    <span v-if="data.item.email">
                                      {{ data.item.email }}
                                    </span>
                                    <span v-else> N/A</span>
                                  </template>

                                  <template #cell(itinerary)="data">
                                    <span
                                      class="uppercase"
                                      v-if="data.item.flightNumber"
                                      >{{ data.item.flightNumber }}</span
                                    >
                                    <span v-else>N/A</span>
                                  </template>

                                  <template #cell(type)="data">
                                    {{ formatPassengerType(data.item.type) }}
                                  </template>
                                  <template #cell(notify)="data">
                                    {{ data.item.notify ? "Yes" : "No" }}
                                  </template>
                                </b-table>
                              </div>
                            </div>
                          </FadeTransition>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="
                          reservation.childSeatsCount > 0 ||
                            reservation.special_requirements
                        "
                      >
                        <div class="card pb-2 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Extras</span>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="reservation.special_requirements"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Special Requirements</span
                                >
                                <span class="content-block">
                                  {{ reservation.special_requirements }}
                                </span>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="reservation.childSeatsCount > 0"
                            >
                              <div class="data-block">
                                <span class="title-block">Child Seats N°</span>
                                <span class="content-block"
                                  >{{ reservation.childSeatsCount }} Seats</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.keyDetails"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Key Details</span>
                            <span class="content-block">
                              {{ service.keyDetails }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2" v-if="service">
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Cancellations Policies</span
                            >
                          </div>

                          <ul class="cancellations-list">
                            <li
                              v-for="(item,
                              index) in service.cancellationPolicy"
                              :key="`${index}`"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.termsConditions"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Terms and Conditions</span
                            >
                            <span class="content-block">
                              {{ service.termsConditions }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  :operation="'new'"
                  :mode="'view'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(
                      reservation.service,
                      reservation.customer
                    )
                  "
                  :commissions="reservation.commissions"
                  :surcharges="reservation.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div
                    v-if="stage === 'RESERVATION'"
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                  >
                    <div class="card py-3">
                      <div class="row">
                        <div class="col-12">
                          <h2 class="subtitle mb-1">Payment Details</h2>

                          <div class="item-selected">
                            <span>
                              <strong>Payment Type: </strong>
                              {{
                                formatPaymentType(reservation.payment_type)
                              }}</span
                            >
                          </div>

                          <div
                            class="item-selected"
                            v-if="reservation.invoice_number"
                          >
                            <span>
                              <strong>Invoice N°: </strong>
                              {{ reservation.invoice_number }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="reservation.invoice_number"
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>

                          <div
                            class="item-selected"
                            v-if="reservation.payment_reference"
                          >
                            <span v-if="reservation.payment_reference">
                              <strong>Payment Reference N°: </strong>
                              {{ reservation.payment_reference }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="
                                    reservation.payment_reference
                                  "
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="
                      reservation.booking_reference || reservation.deal_number
                    "
                  >
                    <div class="card card py-3">
                      <h2 class="subtitle mb-1">External References</h2>

                      <div
                        class="item-selected"
                        v-if="reservation.booking_reference"
                      >
                        <span>
                          <strong>Reservation Reference: </strong>
                          {{ reservation.booking_reference }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.booking_reference"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>

                      <div class="item-selected" v-if="reservation.deal_number">
                        <span>
                          <strong>Zoho Deal Number: </strong>
                          {{ reservation.deal_number }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.deal_number"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="mode === 'list'" class="col-12">
          <div class="card">
            <div class="review">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Address / Date & Time</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation type:</label
                    >
                    <span>{{ formatTransferType(reservation.type) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pick Up Date:</label>
                    <span> {{ getFormatDate(reservation.pickup_date) }}</span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Pick Up Time:</label>
                    <span> {{ getFormatTime(reservation.pickup_time) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">From:</label>
                    <span>{{ reservation.from }}</span>
                  </div>

                  <div v-if="reservation.type !== 'hourly'">
                    <label class="form-control-label pr-1">To:</label>
                    <span>{{ reservation.to }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX N°:</label>
                    <span>{{ reservation.passengersCount }} PAX</span>
                  </div>

                  <div>
                    <div v-if="reservation.type !== 'journey'">
                      <label class="form-control-label pr-1">
                        {{ formatTransportTypeLabel(reservation.type) }}
                      </label>
                      <TransportReference
                        link-class="text-link"
                        :reservation="reservation"
                        :loading="loaderVerifyFlight"
                        @track="getFlightsInformationByIdent"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Service / Supplier</h4>

                  <div>
                    <label class="form-control-label pr-1">Supplier:</label>
                    <span v-if="supplier !== null">
                      {{ getSupplierName(reservation.supplier) }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Destination:</label>
                    <span v-if="branch !== null">
                      {{ getBranchName(reservation.branch) }}</span
                    >
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Service Type:</label>
                    <span v-if="service !== null">
                      {{ formatServiceCategory(service.vehicle.category) }}
                      {{ service.vehicle.seats }} seats
                    </span>
                  </div>
                  <div v-if="service !== null">
                    <label class="form-control-label pr-1">Vehicle:</label>
                    <span v-if="service !== null">
                      {{ service.vehicle.make_label }} or Similar
                    </span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">PAX / Customer</h4>

                  <div>
                    <label class="form-control-label pr-1">Customer:</label>

                    <span class="capitalize" v-if="customer.first_name"
                      >{{ customer.first_name }} {{ customer.last_name }} -
                      {{ formatClientType(customer.type) }}</span
                    >
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX:</label>
                    <span class="capitalize" v-if="passenger.fullName">
                      {{ getTitleByGender(passenger.gender) }}
                      {{ passenger.fullName }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Email:</label>
                    <span>{{ passenger.email }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Contact Number:</label
                    >
                    <span>{{ passenger.phone }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pickup Sign:</label>
                    <span
                      v-if="pdfDataUrl"
                      class="link ml-0"
                      @click="openPreviewPickup()"
                      ><i class="flaticon-visualization mr-1"></i>File
                      uploaded</span
                    >

                    <span class="break-word" v-else>{{
                      reservation.pickupSign.text
                    }}</span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <div
                    v-if="
                      reservation.childSeatsCount > 0 ||
                        reservation.special_requirements
                    "
                    class="mb-4"
                  >
                    <h4 class="subtitle mb-2">Extras</h4>

                    <div v-if="reservation.special_requirements">
                      <label class="form-control-label pr-1"
                        >Special Requirements:</label
                      >
                      <span class="break-word">
                        {{ reservation.special_requirements }}
                      </span>
                    </div>

                    <div v-if="reservation.childSeatsCount > 0">
                      <label class="form-control-label pr-1">
                        Child Seats N°:
                      </label>
                      <span class="break-word"
                        >{{ reservation.childSeatsCount }} Seats</span
                      >
                    </div>
                  </div>

                  <h4 class="subtitle mb-2">Pricing / Payment</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Total Charges:</label
                    >
                    <span>
                      {{ currency.symbol }}
                      {{ parsePrice(reservation.pricing.totals.gross_price) }}
                      {{ currency.code }}
                    </span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Payment Type:</label>
                    <span>
                      {{ formatPaymentType(reservation.payment_type) }}</span
                    >
                  </div>

                  <div v-if="reservation.invoice_number">
                    <label class="form-control-label pr-1">Invoice N°:</label>
                    <span>{{ reservation.invoice_number }}</span>
                  </div>

                  <div v-if="reservation.payment_reference">
                    <label class="form-control-label pr-1"
                      >Payment Reference N°:</label
                    >
                    <span> {{ reservation.payment_reference }}</span>
                  </div>

                  <div v-if="reservation.booking_reference">
                    <label class="form-control-label pr-1"
                      >Reservation Reference:</label
                    >
                    <span>{{ reservation.booking_reference }}</span>
                  </div>

                  <div v-if="reservation.deal_number">
                    <label class="form-control-label pr-1"
                      >Zoho Deal Number:</label
                    >
                    <span> {{ reservation.deal_number }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service && service.keyDetails">
            <div class="data-block mb-2">
              <span class="title-block f-14">Key Details</span>
              <span class="content-block"> {{ service.keyDetails }}</span>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service">
            <div class="data-block mb-2">
              <span class="title-block f-14">Cancellations Policies</span>
            </div>

            <ul class="cancellations-list">
              <li
                v-for="(item, index) in service.cancellationPolicy"
                :key="`${index}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <div class="card pb-3 mb-0" v-if="service && service.termsConditions">
            <div class="data-block mb-2">
              <span class="title-block f-14">Terms and Conditions</span>
              <span class="content-block"> {{ service.termsConditions }}</span>
            </div>
          </div>
        </div>

        <div v-show="mode === 'edit'" class="forms">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="card pb-4">
                      <h2 class="subtitle">Type Transfer</h2>
                      <div
                        class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                      >
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="reservation.type"
                          :options="reservationOptions"
                          name="radios-btn-default"
                          buttons
                          value-field="value"
                          text-field="label"
                          button-variant="group-neutral"
                          tabindex="1"
                          class="buttons-type"
                          @change="changeReservationTransferType"
                        ></b-form-radio-group>
                      </div>

                      <div
                        class="d-xl-none d-lg-none d-md-none d-sm-none d-block"
                      >
                        <WSelect
                          placeholder="Reservation Type"
                          v-model="reservation.type"
                          filterable
                          id="reservationType"
                          class="mb-0"
                        >
                          <el-option
                            v-for="option in reservationOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>

                  <!-- address/date/time/ -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Address / Date & Time</h2>
                      <div class="row">
                        <div class="col-12">
                          <WSelect
                            label="From"
                            v-bind:class="{
                              'is-invalid': $v.reservation.from.$error
                            }"
                            id="from"
                            name="from"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationFrom"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.from.$model"
                            @change="selectFrom"
                            indexTab="2"
                            ref="from"
                            :focusact="true"
                            no-data-text="Search by destination or landmark"
                            clearable
                            alltext
                            markrequired
                            :error="fromValidationMessage($v.reservation.from)"
                          >
                            <el-option
                              v-for="(location, index) in optionsFrom"
                              class
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-show="reservation.type !== 'hourly'"
                        >
                          <WSelect
                            label="To"
                            v-bind:class="{
                              'is-invalid': $v.reservation.to.$error
                            }"
                            id="to"
                            name="to"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationTo"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.to.$model"
                            @change="selectTo"
                            indexTab="3"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            markrequired
                            :error="toValidationMessage($v.reservation.to)"
                          >
                            <el-option
                              v-for="(location, index) in optionsTo"
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Date"
                            :error="
                              $v.reservation.pickup_date.$error
                                ? `Select Pickup Date`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'd-M-Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                                allowInput: true,
                                minDate: 'today'
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_date"
                              @input="getRatesWithThePickupDate"
                              id="date"
                              name="date"
                              placeholder="Pickup Date"
                              tabindex="4"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Time"
                            :error="
                              $v.reservation.pickup_time.$error
                                ? `Select Pickup Time`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'G:i K',
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: 'G:i K',
                                time_24hr: false,
                                wrap: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_time"
                              @input="getRatesWithThePickupTime"
                              id="time"
                              name="time"
                              placeholder="Pickup Time"
                              tabindex="5"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                          <base-input
                            class
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.passengersCount.$model
                            "
                            label="PAX N°"
                            placeholder="PAX N°"
                            id="passengers"
                            name="passengers"
                            mode="integer"
                            indexTab="6"
                            markrequired
                            :error="
                              passengerCountValidationMessage(
                                $v.reservation.passengersCount
                              )
                            "
                            @input="getRatesWithTheNumberPassengers"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                          v-if="
                            ['airport', 'arrival', 'departure'].includes(
                              reservation.type
                            )
                          "
                        >
                          <FlightNumberInput
                            v-model="$v.reservation.flight_number.$model"
                            :pickupDate="reservation.pickup_date"
                            :pickupTime="reservation.pickup_time"
                            :flightType="getFlightType(reservation.type)"
                            :validation="$v.reservation.flight_number"
                            :airport="airport"
                            @input="onFlightNumberInput"
                            @validation-state="handleValidationState"
                            @selectFlight="handleFlightSelection"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'station'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.number_stations.$model"
                            label="Rail Line"
                            id="rail_line"
                            name="rail_line"
                            placeholder="Rail Line"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.number_stations.$error
                                ? 'Enter a Valid Rail Line'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'port'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.cruise_line.$model"
                            label="Cruise Ship"
                            id="cruise_line"
                            name="cruise_line"
                            placeholder="Cruise Ship"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.cruise_line.$error
                                ? 'Enter a Valid Cruise Ship'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'hourly'"
                        >
                          <WSelect
                            v-bind:class="{
                              'is-invalid': $v.reservation.number_hourly.$error
                            }"
                            class
                            placeholder="Select Hourly"
                            v-model.trim="$v.reservation.number_hourly.$model"
                            @input="getRatesWithTheHourly"
                            id="number_hourly"
                            name="number_hourly"
                            indexTab="8"
                            label="Hourly"
                            @change="changeRouterReference"
                            :error="
                              $v.reservation.number_hourly.$error
                                ? 'Select an Hours'
                                : ''
                            "
                          >
                            <el-option
                              v-for="number in minimumSelect"
                              :value="number"
                              :label="number"
                              :key="number"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-if="reservation.flight_number && flight"
                        >
                          <FlightDetails mode="view" :flight="flight" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- service/Supplier -->
                  <div class="col-xl-12">
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                        >
                          <h2 class="subtitle">Service / Supplier</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="serviceAux.length > 0"
                          >
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Supplier"
                                v-model="supplierFilter"
                                id="supplierFilter"
                                name="supplierFilter"
                                filterable
                                :loading="loading"
                                indexTab="10"
                                @change="changeSupplier"
                                label="Supplier"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="supplier in suppliersOptions"
                                  :value="supplier._id"
                                  :label="supplier.businessDetails.name"
                                  :key="supplier._id"
                                ></el-option>
                              </WSelect>
                            </div>
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Destination"
                                v-model="branchFilter"
                                id="branchFilter"
                                name="branchFilter"
                                filterable
                                indexTab="11"
                                @change="changeBranch"
                                label="Destination"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="branch in branchesAux"
                                  :value="branch._id"
                                  :label="branch.name"
                                  :key="branch._id"
                                ></el-option>
                              </WSelect>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="col-xl-12">
                          <base-alert
                            v-if="loaderService == 'INIT'"
                            type="info"
                            class="mb-0 info-min"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Waiting search!</strong>
                            Select Address, Date and PAX N° to see the available
                            services
                          </base-alert>
                          <base-alert
                            v-if="loaderService == 'NOT_FOUND'"
                            type="danger"
                            class="mb-4 info-min"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Not Found!</strong> There are no services
                            available for your search. Check the from and to.
                          </base-alert>

                          <div class="container-services">
                            <div class="content-service">
                              <div v-if="loaderService === 'RESULTS'">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                  v-for="(element, index) in serviceAux"
                                  :key="index"
                                >
                                  <Services
                                    :selected="
                                      getSelectServices(service, element)
                                    "
                                    :suppliers="suppliersOptions"
                                    :branches="branchesOptions"
                                    :service="element"
                                    :transferType="reservation.type"
                                    :hourly="reservation.number_hourly"
                                    @selectService="processServiceSelection"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="loaderService === 'SEARCHING'">
                            <div class="text-center pt-0 pb-4">
                              <h4><strong>Finding services...</strong></h4>
                              <span class="loader-pin"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- customer  -->
                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-4">Customer</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.reservation.customer.$error
                            }"
                            class
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="customerId"
                            id="customer"
                            name="customer"
                            indexTab="13"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            :error="
                              $v.reservation.customer.$error
                                ? 'Enter a Customer'
                                : ''
                            "
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="getCustomerLabel(customer)"
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7">
                                  <span
                                    class="role-table"
                                    v-if="
                                      [
                                        'travel_agency',
                                        'travel_access'
                                      ].includes(customer.type)
                                    "
                                    >{{ customer.company_name }}</span
                                  >
                                  <span
                                    >{{ customer.first_name }}
                                    {{ customer.last_name }}</span
                                  >
                                </div>
                                <div class="col-5 text-right hide-data">
                                  <span class="coin-right">{{
                                    formatClientType(customer.type)
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              tabindex="14"
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <AddCustomer
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        />
                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- passengers -->
                  <div class="col-xl-12">
                    <div class="card">
                      <div class="row mb-2">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-8 align-self-center"
                        >
                          <h2 class="subtitle">PAX</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-4 text-right form-group-no-margin align-self-center"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button mb-0"
                            @click="importPassengers"
                          >
                            <i class="flaticon-up-2"></i> Import
                            <input
                              type="file"
                              ref="fileInput"
                              accept=".csv"
                              class="d-none"
                              @change="bulkPassengers"
                            />
                          </base-button>
                          <base-button
                            class="min-button mb-0"
                            type="outline-neutral"
                            @click="addNewPassenger"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>

                      <NewPassenger
                        :show="showNewPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :passengers="passengers"
                        :passengersIncluded="reservation.passengers"
                        :maxPassengers="
                          reservation.passengersCount
                            ? reservation.passengersCount
                            : 0
                        "
                        :transferType="reservation.type"
                        @addPassenger="addPassenger"
                        @close="closeNewPassengerModal"
                      />
                      <EditPassenger
                        :show="showEditPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :tempPassenger="tempPassenger"
                        :transferType="reservation.type"
                        @changePassenger="upadtePassenger"
                        @close="closeEditPassengerModal"
                      />

                      <div
                        class="mb-4"
                        v-if="reservation.passengers.length === 0"
                      >
                        <base-alert type="warning" class="mb-1 info-min">
                          <i class="flaticon-warning mr-1"></i> There are no PAX
                          here
                        </base-alert>
                      </div>

                      <div
                        class="list-card"
                        v-if="reservation.passengers.length === 1"
                      >
                        <div
                          class="card card-min"
                          v-for="(element, index) in reservation.passengers"
                        >
                          <div class="row">
                            <div
                              class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 align-self-center"
                            >
                              <div class="row">
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <div>
                                      <span class="content-block"
                                        ><strong>Full Name:</strong>
                                        {{ getTitleByGender(element.gender) }}
                                        {{ element.firstName }}
                                        {{ element.lastName }}
                                      </span>

                                      <span
                                        v-if="element.phone"
                                        class="content-block"
                                        ><strong>Contact Number:</strong>
                                        {{ element.phone }}
                                        <el-tooltip
                                          content="Copy"
                                          placement="bottom"
                                        >
                                          <span
                                            class="curp ml-2"
                                            v-clipboard:copy="element.phone"
                                            v-clipboard:success="onCopy"
                                            v-clipboard:error="onErrorCopy"
                                          >
                                            <i
                                              class="flaticon-copy link ml-0"
                                            ></i></span
                                        ></el-tooltip>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <span
                                      v-if="element.email"
                                      class="content-block"
                                      ><strong>Email:</strong>
                                      {{ element.email }}
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="element.email"
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </span>
                                    <span class="content-block"
                                      ><strong>Segment:</strong>
                                      {{ formatPassengerType(element.type) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 align-self-center alinmov6"
                            >
                              <el-tooltip
                                content="Edit"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="
                                    openEditPassengerModal(element, index)
                                  "
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </span>
                              </el-tooltip>

                              <el-tooltip
                                content="Copy data"
                                placement="bottom"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="copyPassengerData(element)"
                                >
                                  <i class="flaticon-copy text-black"></i>
                                </span>
                              </el-tooltip>
                              <el-tooltip
                                content="Remove"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action"
                                  @click.stop="
                                    removePassenger(index, element.primary)
                                  "
                                >
                                  <i class="flaticon-cancel text-danger"></i>
                                </span>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="reservation.passengers.length > 1">
                        <b-table
                          hover
                          :items="reservation.passengers"
                          :fields="
                            getHeaderPassengerTable(
                              fieldsPassenger,
                              reservation.type
                            )
                          "
                          sort-by.sync="created_at"
                          sort-desc.sync="true"
                          selectable
                          @row-selected="onRowSelected"
                          select-mode="multi"
                          ref="selectableTable"
                          sort-icon-left
                          responsive
                          show-empty
                          empty-filtered-text="There are no records matching your request"
                          empty-text="There are no records to show"
                        >
                          <template #head()="{ label, field: { key } }">
                            <span v-if="key === 'selected'">
                              <span
                                @click="clearSelected"
                                v-if="
                                  selectedRows.length ==
                                    reservation.passengers.length
                                "
                                class="check-table selected"
                              ></span>

                              <span
                                @click="selectAllRows"
                                v-else
                                class="check-table"
                              ></span>
                            </span>
                            <span v-else>{{ label }}</span>
                          </template>

                          <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                              <span
                                aria-hidden="true"
                                class="check-table selected"
                              ></span>
                              <span class="sr-only">Selected</span>
                            </template>
                            <template v-else>
                              <span
                                aria-hidden="true"
                                class="check-table"
                              ></span>
                              <span class="sr-only">Not selected</span>
                            </template>
                          </template>

                          <template #cell(fullname)="data">
                            <span class="text-capitalize"
                              >{{ getTitleByGender(data.item.gender) }}
                              {{ data.item.firstName }}
                              {{ data.item.lastName }}
                            </span>

                            <span
                              class="badge-status badge-default mr-2"
                              v-if="data.item.primary"
                              >Primary</span
                            >
                          </template>

                          <template #cell(phone)="data">
                            <span v-if="data.item.phone">{{
                              data.item.phone
                            }}</span>
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(email)="data">
                            <span
                              class="hide-data lower"
                              v-if="data.item.email"
                            >
                              {{ data.item.email }}
                            </span>
                            <span v-else> N/A</span>
                          </template>

                          <template #cell(itinerary)="data">
                            <span
                              class="uppercase"
                              v-if="data.item.flightNumber"
                              >{{ data.item.flightNumber }}</span
                            >
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(type)="data">
                            {{ formatPassengerType(data.item.type) }}
                          </template>
                          <template #cell(notify)="data">
                            {{ data.item.notify ? "Yes" : "No" }}
                          </template>

                          <template #cell(actions)="data">
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="
                                  openEditPassengerModal(data.item, data.index)
                                "
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark as primary"
                              placement="bottom"
                              v-if="!data.item.primary"
                            >
                              <span
                                class="icon-action mr-2"
                                @click.stop="makePassengerAsDefault(data.index)"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Copy data" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="copyPassengerData(data.item)"
                              >
                                <i class="flaticon-copy text-black"></i>
                              </span>
                            </el-tooltip>
                            <el-tooltip content="Remove" placement="bottom">
                              <span
                                class="icon-action"
                                @click.stop="
                                  removePassenger(data.index, data.item.primary)
                                "
                              >
                                <i class="flaticon-cancel text-danger"></i>
                              </span>
                            </el-tooltip>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle">Pickup Sign</h2>

                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 align-self-center"
                        >
                          <div v-if="pdfDataUrl">
                            <div class="pdfPreview mb-4">
                              <iframe
                                :src="pdfDataUrl"
                                width="235px"
                                height="160px"
                                frameborder="0"
                                allowfullscreen
                                class="pdf-iframe"
                                scrolling="no"
                              ></iframe>

                              <el-tooltip
                                content="Open / Expand"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-expand"
                                  @click="openPreviewPickup()"
                                >
                                  <i class="flaticon-expand"></i></div
                              ></el-tooltip>

                              <el-tooltip
                                content="Remove Pickup Sign"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-remove"
                                  @click="clearfile()"
                                >
                                  <i class="flaticon-delete"></i></div
                              ></el-tooltip>
                            </div>
                          </div>

                          <el-input
                            v-else
                            v-model="reservation.pickupSign.text"
                            placeholder="Pickup Sign"
                            id="pickupSign"
                            name="pickupSign"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                          v-if="!pdfDataUrl"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button"
                            @click="uploadPickupSign"
                          >
                            <i class="flaticon-up-2"></i> Upload Pickup Sign
                            <input
                              type="file"
                              ref="pickupSign"
                              accept=".pdf"
                              model="pickupSign"
                              @change="readPickupSign"
                              class="d-none"
                            />
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-3">Extras</h2>

                      <div class="row">
                        <div
                          class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                        >
                          <label class="title-label" for="specialrequirements"
                            >Special Requirements</label
                          >
                          <el-input
                            v-model="reservation.special_requirements"
                            placeholder="Special Requirements"
                            id="Special Requirements"
                            name="Special Requirements"
                            maxlength="500"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 10 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.childSeatsCount.$model
                            "
                            mode="integer"
                            label="Child Seats N°"
                            id="child_seat"
                            name="child_seat"
                            placeholder="Child Seat"
                            indexTab="7"
                            :error="
                              childSeatsCountValidationMessage(
                                $v.reservation.childSeatsCount
                              )
                            "
                          />
                        </div>

                        <div
                          class="col-12 mt-0 mb-4"
                          v-if="reservation.childSeatsCount > 0"
                        >
                          <base-alert type="warning" class="mb-0 info-min">
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Important!</strong>
                            <span class="span-alert">
                              <strong>You are adding a child seat(s)</strong>
                              You must verify with the supplier that the
                              requested child seat(s) can be fulfilled. Even if
                              child seats have no additional cost, they must be
                              registered as extras in the system with a price of
                              20 USD/EUR once the supplier has confirmed
                              availability. If any additional costs apply, add
                              the extra to the reservation and contact the
                              customer to process the payment. After adding the
                              extra, send a notification to the customer
                              confirming the update.
                            </span>
                          </base-alert>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  :operation="'new'"
                  :mode="'edit'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(
                      reservation.service,
                      reservation.customer
                    )
                  "
                  :commissions="reservation.commissions"
                  :surcharges="reservation.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div
                    v-if="stage === 'RESERVATION'"
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
                  >
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">Payment Details</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <WSelect
                            placeholder="Payment Type"
                            v-model="reservation.payment_type"
                            id="paymentType"
                            name="paymentType"
                            @change="changePaymentType"
                            label="Payment Type"
                          >
                            <el-option
                              v-for="option in paymentMethods"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <base-input
                            v-model.trim="reservation.invoice_number"
                            type="text"
                            label="Invoice Number"
                            placeholder="Invoice Number"
                            id="invoice_number"
                            name="invoice_number"
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        >
                          <base-input
                            type="text"
                            label="Payment Reference N°"
                            placeholder="Payment Reference N°"
                            v-model="reservation.payment_reference"
                            id="paymentreference"
                            name="paymentreference"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Reservation Reference"
                            placeholder="Reservation Reference"
                            v-model="$v.reservation.booking_reference.$model"
                            id="booking_reference"
                            name="booking_reference"
                            indexTab="28"
                            :error="
                              $v.reservation.booking_reference.$error
                                ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-7 col-sm-7 col-12"
                        >
                          <base-input
                            placeholder="Zoho Deal Number"
                            v-model.trim="$v.reservation.deal_number.$model"
                            id="deal_number"
                            name="deal_number"
                            label="Zoho Deal Number"
                            type="text"
                            :error="
                              dealNumberValidationMessage(
                                $v.reservation.deal_number
                              )
                            "
                          ></base-input>
                        </div>
                        <div
                          class="col-xl-12 col-lg-6 col-md-7 col-sm-7 col-12"
                        >
                          <WSelect
                            label="Event"
                            placeholder="Select Event"
                            v-model="reservation.event"
                            filterable
                            clearable
                            id="event"
                            name="event"
                            class="mb-0"
                          >
                            <el-option
                              v-for="option in eventOptions"
                              :value="option.value"
                              :label="option.label"
                              :key="option.value"
                            ></el-option>
                          </WSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ManageExtraCharges
      :show="showExtrasModal"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :extras="reservation.pricing.extras"
      :currency="currency"
      @change="manageExtras"
      @close="closeExtrasModal"
    />
    <ManageDiscounts
      :show="showDiscountModal"
      :grossPrice="reservation.pricing.totals.gross_price"
      :discounts="reservation.pricing.discounts"
      :currency="currency"
      @change="manageDiscounts"
      @close="closeDiscountModal"
    />
    <ManagePriceAdjustments
      :show="showPriceAdjusments"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :lastGrossPrice="lastGrossPrice"
      :lastNetPrice="lastNetPrice"
      :currency="currency"
      @change="managePriceAdjusments"
      @close="closePriceAdjusments"
    />
    <modal
      v-if="pdfDataUrl"
      :show.sync="showPreviewPickupSign"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pt-1"
    >
      <template slot="header">
        <h4 class="subtitle mb-0" id="BlackoutDate">Pickup Sign</h4>
      </template>

      <iframe
        :src="`${pdfDataUrl}#zoom=100`"
        width="100%"
        height="600px"
      ></iframe>
    </modal>

    <CutoffTimeConfirmationModal
      :show.sync="showCutoffModal"
      :bookingData="buildBookingSummary(reservation, service, passenger)"
      modal-classes="modal-dialog-centered modal-lg"
      no-close-on-backdrop
      @close="handleCutoffModalClose"
      @submitAvailabilityRequest="handleSubmitAvailabilityRequest"
    />
    <EventPeriodAvailabilityModal
      :show.sync="showEventPeriodModal"
      :bookingData="buildBookingSummary(reservation, service, passenger)"
      modal-classes="modal-dialog-centered modal-lg "
      no-close-on-backdrop
      @close="handleEventPeriodModalClose"
      @submitAvailabilityRequest="handleSubmitAvailabilityRequest"
    />
    <AvailabilityRequestSuccessModal
      :show.sync="showRequestSuccessModal"
      :quoteNumber="transferQuote ? transferQuote.booking_number : ''"
      :customeEmail="'jesus.flores@ivelopment.com'"
      modal-classes="modal-dialog-centered modal-md "
      no-close-on-backdrop
      @viewRequest="handleViewRequest"
      @searchOtherServices="handleSearchOtherServices"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
moment.suppressDeprecationWarnings = true;
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  ReservationsAPI,
  FlightsAPI,
  CountriesAPI,
  PassengersAPI,
  QuotesAPI,
  PaymentsAPI
} from "../../../../core/api";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomer from "@/components/transfer/AddCustomer.vue";
import { cloneDeep, isEqual } from "lodash";
import Swal from "sweetalert2";
import NewPassenger from "@/components/passengers/NewPassenger.vue";
import EditPassenger from "@/components/passengers/EditPassenger.vue";
import Charges from "@/components/price-composition/Charges.vue";
import ManageExtraCharges from "@/components/price-composition/ManageExtraCharges.vue";
import ManageDiscounts from "@/components/price-composition/ManageDiscounts.vue";
import ManagePriceAdjustments from "@/components/price-composition/ManagePriceAdjustments.vue";
import Services from "@/components/transfer/Services.vue";
import { FadeTransition } from "vue2-transitions";
import FlightNumberInput from "@/components/transfer/flightValidation/FlightNumberInput.vue";
import FlightDetails from "@/components/transfer/flightValidation/FlightDetails.vue";
import CutoffTimeConfirmationModal from "@/components/modals/CutoffTimeConfirmationModal.vue";
import EventPeriodAvailabilityModal from "@/components/modals/EventPeriodAvailabilityModal.vue";
import AvailabilityRequestSuccessModal from "@/components/modals/AvailabilityRequestSuccessModal.vue";
import TransportReference from "../../components/TransportReference.vue";
import {
  required,
  minLength,
  maxLength,
  alphaNum,
  minValue,
  maxValue,
  numeric,
  decimal,
  integer,
  requiredIf
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect
} from "element-ui";
import Papa from "papaparse";
import {
  PAYMENT_METHODS,
  RESERVATION_OPTIONS,
  RESERVATION_TYPES,
  populateToOptions,
  populateFromOptions,
  getFormatDate,
  getFormatTime,
  getFlightType
} from "../../../../helpers/reservation.helpers";
import {
  validateHeadersFile,
  parseContentFile,
  getPassengerToRegister
} from "../../../../core/services/passenger.service";
import {
  calculateCommissionAmount,
  calculateTotalDiscounts,
  calculateTotalExtraGrossPrice,
  calculateTotalExtrasNetPrice,
  calculateTotalGrossPrice,
  calculateTotalNetPrice,
  calculateTotalNetProfit,
  getCommissionByCustomer,
  isSamePriceComposition,
  isSameSurchargesComposition
} from "../../../pricing";

import {
  goBack,
  isPartner,
  isUnauthorizedError,
  isUserAuthorized,
  setSigOut
} from "../../../../helpers/commons.helpers";
import { FileService } from "../../../../core/services";
import {
  generateMessageToNotify,
  getPickupDate,
  getPickupTime
} from "../../services/flight.service";
import {
  dealNumberValidationMessage,
  childSeatsCountValidationMessage,
  fromValidationMessage,
  passengerCountValidationMessage,
  toValidationMessage,
  validateContentFile
} from "../../services/validation.service";
import { calculateTotalPrice } from "../../../pricing";
import debounce from "lodash.debounce";
import {
  formatClientType,
  formatPassengerType,
  formatPaymentType,
  formatServiceCategory,
  formatTransferType,
  formatTransportTypeLabel,
  getIcon,
  getCustomerLabel,
  parsePrice,
  getTitleByGender,
  getHeaderPassengerTable
} from "../../services/format.service";
import {
  canBeRequoted,
  handleCutOffConfirmation,
  handleBlackoutConfirmation,
  buildUtcPickupDateTime,
  resolveConfirmationReason,
  getTypeLocation,
  getOriginData,
  getDestinationData,
  getServiceById,
  conversionCurrency,
  calculateGroosPrice,
  getReservationType,
  getRouterReferenceValue,
  getRouterReference,
  getSelectServices,
  getAdjustmentsStatus
} from "../../services/quote.service";
import {
  alphabeticallySort,
  getOwner,
  getConfigTag
} from "../../services/client.service";
import { loadEventOptions } from "../../services/event.service";
import {
  FIELDS_PASSENGER,
  FIELDS_PASSENGER_VIEW,
  MINIMUM_SELECT
} from "../../../../core/constants";
import {
  buildBookingSummary,
  mapQuoteFromBooking,
  populateService,
  parsePassengers,
  getPickupSignByPrimaryPassenger,
  getCustomerById,
  getAgentId,
  populateReservationAgent
} from "../../services/populate.service";
import {
  CAPTURE_MODE_IMMEDIATE,
  PAYMENT_METHOD
} from "../../constants/reservation.constants";
import { TransferPricingAPI } from "../../../../core/api/transfer-pricing.api.js";

export default {
  name: "NewReservations",
  data() {
    return {
      eventOptions: [],
      reservation: {
        from: "",
        to: "",
        pickup_date: "",
        pickup_time: "",
        passengersCount: 0,
        childSeatsCount: 0,
        type: "arrival",
        supplier: null,
        branch: null,
        service: null,
        driver: null,
        vehicle: null,
        payment_type: "card",
        flight_number: "",
        transfer: "one-way",
        customer: null,
        booking_reference: "",
        pickupSign: {
          format: "CUSTOM",
          text: "",
          link: ""
        },
        special_requirements: "",
        number_hourly: 0,
        number_stations: "",
        cruise_line: "",
        invoice_number: "",
        payment_reference: "",
        surcharges: [],
        locations: {
          from: {
            lat: 0,
            lng: 0
          },
          to: {
            lat: 0,
            lng: 0
          }
        },
        distancematrix: {
          distance: 0,
          duration: 0
        },
        owner: "admin",
        originData: null,
        destinationData: null,
        agent: null,
        product: null,
        passenger: null,
        metadata: {},
        passengers: [],
        deal_number: "",
        event: null,
        pricing: {
          net_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          base_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          gross_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          net_profit: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          sale_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          discounts: [],
          extras: [],
          totals: {
            discounts: 0.0,
            extras: {
              gross_price: 0.0,
              net_price: 0.0,
              net_profit: 0.0
            },
            net_price: 0.0,
            gross_price: 0.0,
            net_profit: 0.0
          },
          reason_adjustment: ""
        },
        responsible: {
          type: "Users",
          ref: ""
        },
        notificaition: {
          configTag: "rhomtrip_internal",
          configRef: null
        },
        commissions: {
          payment_processor: {
            amount: 0.0,
            percentage: 0.0
          },
          platform: {
            amount: 0.0,
            percentage: 0.0
          }
        },
        source: {
          origin: "RhomTrip Internal",
          type: "INTERNAL",
          provider: "RHOMTRIP",
          channel: "SYSTEM",
          medium: "APP"
        },
        flight: null
      },
      distance: 0,
      paymentMethods: PAYMENT_METHODS,
      reservationOptions: RESERVATION_OPTIONS,
      services: [],
      all_services: [],
      serviceAux: [],
      branchesAux: [],
      minimumSelect: MINIMUM_SELECT,
      customer: {
        currency: {
          code: "",
          symbol: "",
          label: ""
        },
        credit: {
          status: false,
          limit: 0,
          available: 0
        },
        _id: "",
        first_name: "",
        last_name: "",
        company_name: "",
        mark_up: 0,
        type_markup: "markup",
        email: "",
        phone: "",
        type: ""
      },
      suppliersOptions: [],
      branchesOptions: [],
      dirversOptions: [],
      supplierFilter: "",
      branchFilter: "",
      supplier: null,
      branch: null,
      loading: false,
      optionsFrom: [],
      customers: [],
      optionsTo: [],
      service: null,
      requestType: "one_way",
      buttonDisabled: false,
      show: 0,
      reservationCopy: {},
      saved: false,
      currency: {
        symbol: "",
        code: ""
      },
      copyData: false,
      timezone: "",
      drivers: [],
      country_code: "",
      modalCustomer: false,
      showRates: false,
      creditAvailable: true,
      originData: null,
      destinationData: null,
      loaderService: "INIT",
      viewServices: "table",
      debouncedRequote: null,
      customerId: null,
      showNewPassengerModal: false,
      fieldsPassenger: FIELDS_PASSENGER,
      passengers: [],
      showEditPassengerModal: false,
      tempPassenger: null,
      passengerIndex: null,
      types: RESERVATION_TYPES,
      mode: "edit",
      showDiscountModal: false,
      showExtrasModal: false,
      fieldsPassengerView: FIELDS_PASSENGER_VIEW,
      showPriceAdjusments: false,
      lastGrossPrice: 0,
      lastNetPrice: 0,
      pdfDataUrl: null,
      showPreviewPickupSign: false,
      routerReference: {
        transferType: "arrival",
        value: ""
      },
      contactNumber: "",
      flightType: "NONE",
      flight: null,
      airport: null,
      flightValidationRoles: {},
      loaderVerifyFlight: false,
      requiresAvailabilityConfirmation: false,
      showCutoffModal: false,
      showEventPeriodModal: false,
      showRequestSuccessModal: false,
      redirectTo: null,
      transferQuote: null,
      stage: "RESERVATION"
    };
  },
  watch: {
    customerOptions: {
      handler: function(current, old) {
        this.customers = current;
      },
      deep: true
    }
  },
  async created() {
    this.debouncedRequote = debounce(this.requote, 500);
    this.stage = this.$route.meta.stage;
    this.setItemsBread(this.$route.meta.bread);
    this.reservation.responsible.ref = getOwner(this.sesion);
    this.reservationCopy = Object.assign({}, this.reservation);
    this.customers = this.customerOptions;
    const recordId = this.$route.query.recordId;
    if (recordId) {
      await this.loadReservation(recordId);
      this.$router.replace({ path: this.$route.path });
    }
    this.eventOptions = await loadEventOptions(
      this.sesion.token,
      this.reservation.event
    );
  },
  methods: {
    // <<<<<<<<<<<<<<<<<<<< Formatting & Validation Helpers >>>>>>>>>>>>>>>>>>>>
    getFlightType,
    getFormatDate,
    getFormatTime,
    fromValidationMessage,
    toValidationMessage,
    dealNumberValidationMessage,
    formatPaymentType,
    formatPassengerType,
    formatServiceCategory,
    formatTransferType,
    formatClientType,
    formatTransportTypeLabel,
    passengerCountValidationMessage,
    childSeatsCountValidationMessage,
    buildBookingSummary,
    getHeaderPassengerTable,
    getTitleByGender,
    getAdjustmentsStatus,
    parsePrice,
    getIcon,
    getSelectServices,
    getCustomerLabel,
    // <<<<<<<<<<<<<<<<<<<< General Helpers >>>>>>>>>>>>>>>>>>>>
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    /**
     * Flight Methods
     */

    /**
     * Handle flight selection and update reservation details
     * @param {Object} payload - The flight selection payload
     */
    // <<<<<<<<<<<<<<<<<<<< Location Methods >>>>>>>>>>>>>>>>>>>>
    async getLocationFrom(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = getTypeLocation(this.reservation.type, "from");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsFrom = locations;
          } else {
            this.optionsFrom = [];
          }
        } else {
          this.optionsFrom = [];
        }
      } catch (error) {
        this.optionsFrom = [];
      }
    },
    async getLocationTo(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = getTypeLocation(this.reservation.type, "to");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsTo = locations;
          } else {
            this.optionsTo = [];
          }
        } else {
          this.optionsTo = [];
        }
      } catch (error) {
        this.loading = false;
        this.optionsTo = [];
      }
    },
    async populateOringData(from) {
      if (from) {
        let element = this.optionsFrom.find(item => item.select === from);
        if (element) {
          this.country_code = element.country_code;
          if (element.type === "airport") {
            this.originData = element;
            this.reservation.originData = element;
            this.flightType = "ARRIVAL";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.originData = element.place_id ? element : null;
            this.reservation.originData = this.originData;
          }
        }
      }
    },
    async populateDestinationData(to) {
      if (to) {
        let element = this.optionsTo.find(item => item.select === to);
        if (element) {
          if (element.type === "airport") {
            this.destinationData = element;
            this.reservation.destinationData = element;
            this.flightType = "DEPARTURE";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.destinationData = element.place_id ? element : null;
            this.reservation.destinationData = this.destinationData;
          }
        }
      }
    },
    async selectFrom(from) {
      await this.populateOringData(from);
      await this.getRatesWithTheOrigin(from);
    },
    async selectTo(to) {
      await this.populateDestinationData(to);
      await this.getRatesWithTheDestination(to);
    },
    // <<<<<<<<<<<<<<<<<<<< Quotation Methods >>>>>>>>>>>>>>>>>>>>
    buildRateOptionsRequestBody() {
      return {
        passengersCount: this.reservation.passengersCount,
        origin: getOriginData(
          this.originData,
          this.reservation.from,
          this.reservation.type
        ),
        destination: getDestinationData(
          this.destinationData,
          this.reservation.to,
          this.reservation.type
        ),
        pickup_date: this.reservation.pickup_date,
        pickup_time: this.reservation.pickup_time,
        type_request: this.requestType,
        hours: this.reservation.number_hourly,
        arrival: this.flightType === "ARRIVAL",
        childSeatsCount: 0,
        serviceType: "TRANSFER",
        source: "rhombus-v1"
      };
    },
    async getBookingOptions() {
      try {
        let payload = this.buildRateOptionsRequestBody();
        this.loaderService = "SEARCHING";
        let { data } = await TransferPricingAPI.getTransferPricingQuotation(
          payload,
          this.sesion.token
        );
        if (data) {
          this.branchFilter = "";
          this.supplierFilter = "";
          this.drivers = [];
          this.reservation.locations.from = data.origin;
          this.reservation.locations.to = data.destination;
          this.reservation.distancematrix.distance = data.distance;
          this.reservation.distancematrix.duration = data.duration;
          this.timezone = data.timezone;
          this.services = data.services;
          this.all_services = data.all_services;
          this.serviceAux = this.services;
          this.suppliersOptions = data.suppliers;
          this.branchesOptions = data.branches;
          this.dirversOptions = data.drivers;
          this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
        } else {
          this.services = [];
          this.serviceAux = [];
          this.suppliersOptions = [];
          this.branchesOptions = [];
          this.loaderService = "NOT_FOUND";
        }
      } catch (error) {
        this.services = [];
        this.suppliersOptions = [];
        this.branchesOptions = [];
        this.loaderService = "NOT_FOUND";
      }
    },
    async getRatesWithTheOrigin(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          value,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.number_hourly,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheDestination(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          value,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.number_hourly,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupDate(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          value,
          this.reservation.pickup_time,
          this.reservation.number_hourly,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupTime(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          value,
          this.reservation.number_hourly,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheNumberPassengers(value) {
      try {
        const passengersCount = parseInt(value);
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.number_hourly,
          passengersCount
        );
        if (isRequotable && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheHourly(value) {
      try {
        const quotedHours = parseInt(value);
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          quotedHours,
          this.reservation.passengersCount
        );
        if (isRequotable && quotedHours > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async requote() {
      this.showRates = true;
      this.branchFilter = "";
      this.supplierFilter = "";
      this.suppliersOptions = [];
      this.branchesOptions = [];
      this.branchesAux = [];
      await this.getBookingOptions();
      let serviceId = this.service ? this.service._id : null;
      let currentService = getServiceById(serviceId, this.services);
      if (!currentService) {
        const fromAll = getServiceById(serviceId, this.all_services);
        if (fromAll) {
          this.services.unshift(fromAll);
          this.serviceAux = this.services;
          currentService = fromAll;
        }
      }
      if (currentService) {
        this.processServiceSelection(currentService);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Service Selection Methods >>>>>>>>>>>>>>>>>>>>
    changeSupplier(value) {
      if (value !== "") {
        this.branchFilter = "";
        this.branchesAux = this.branchesOptions.filter(branch => {
          return branch.supplier === value;
        });
        this.serviceAux = this.all_services.filter(service => {
          return this.branchesAux
            .map(branch => branch._id)
            .includes(service.branchId);
        });
      } else {
        this.branchFilter = "";
        this.serviceAux = this.services;
      }
    },
    changeBranch(value) {
      if (value !== "") {
        this.reservation.driver = null;
        this.serviceAux = this.all_services.filter(service => {
          return service.branchId === value;
        });
      } else {
        if (this.supplierFilter) {
          this.branchesAux = this.branchesOptions.filter(branch => {
            return branch.supplier === this.supplierFilter;
          });
          this.serviceAux = this.all_services.filter(service => {
            return this.branchesAux
              .map(branch => branch._id)
              .includes(service.branchId);
          });
        }
      }
    },
    async handleBlackoutService(confirmed, service) {
      if (confirmed) {
        await this.handleServiceSelection(service);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleServiceSelection(service) {
      if (this.service) {
        const isCutoffTimeApplied = service.isCutoffTimeApplied;
        const isDifferentServiceId = this.service._id !== service._id;
        if (isDifferentServiceId) {
          await this.validateAndApplyService(service);
          return;
        }

        const samePriceComposition = isSamePriceComposition(
          this.service.basePriceComposition,
          service.basePriceComposition
        );
        const sameSurchargesComposition = isSameSurchargesComposition(
          this.service.surcharges,
          service.surcharges
        );
        let canApplyNewService =
          !samePriceComposition ||
          !sameSurchargesComposition ||
          isCutoffTimeApplied;
        if (canApplyNewService) {
          await this.validateAndApplyService(service);
        }
        return;
      }
      await this.validateAndApplyService(service);
      return;
    },
    async processServiceSelection(service) {
      try {
        if (service.blackout) {
          await handleBlackoutConfirmation(service, this.handleBlackoutService);
        } else {
          await this.handleServiceSelection(service);
        }
      } catch (error) {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async validateAndApplyService(service) {
      this.requiresAvailabilityConfirmation =
        service.isCutoffTimeApplied || service.availabilityOnRequest;

      if (service.isCutoffTimeApplied) {
        await this.applyServiceToReservation(service, this.customer);
        return;
      }

      await this.applyServiceToReservation(service, this.customer);
      return;
    },
    async applyServiceToReservation(service, customer) {
      this.service = service;
      this.reservation.supplier = service.supplierId;
      this.reservation.branch = service.branchId;
      this.reservation.service = service._id;
      this.reservation.vehicle = service.vehicle._id;

      this.reservation.surcharges = service.surcharges;
      this.reservation.pricing.reason_adjustment = "";

      let base_price = parseFloat(service.base_price.toFixed(2));
      this.reservation.pricing.base_price.amount = base_price;
      this.reservation.pricing.base_price.last_amount = base_price;
      this.reservation.pricing.base_price.composition =
        service.basePriceComposition;

      let sale_price = parseFloat(service.sale_price.toFixed(2));
      this.reservation.pricing.sale_price.amount = sale_price;
      this.reservation.pricing.sale_price.last_amount = sale_price;

      let net_price = calculateTotalPrice(
        base_price,
        this.reservation.surcharges,
        "net"
      );
      this.reservation.pricing.net_price.amount = parseFloat(
        net_price.toFixed(2)
      );
      this.reservation.pricing.net_price.last_amount = this.reservation.pricing.net_price.amount;

      this.currency.symbol = service.currency.symbol;
      this.currency.code = service.currency.code;
      if (customer) {
        this.calculePriceByCustomer(
          this.reservation.pricing.net_price.last_amount,
          customer.mark_up,
          customer.type_markup
        );
      }
    },
    async applyAvailabilityConfirmationState(service) {
      if (service.isCutoffTimeApplied) {
        this.showCutoffModal = true;
      }

      if (service.availabilityOnRequest) {
        this.showEventPeriodModal = true;
      }
      return;
    },
    getBranchName(branchId) {
      let branch = this.branchesOptions.find(branch => branch._id === branchId);
      if (branch) {
        return branch.name;
      }
      return "Destination Name";
    },
    getSupplierName(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.businessDetails.name;
      }
      return "Supplier Name";
    },
    getSupplierNotes(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.publicNotes ? supplier.publicNotes : "";
      }
      return "";
    },
    handleCutoffModalClose() {
      this.showCutoffModal = false;
    },
    /**
     * Handle event period modal close event
     */
    handleEventPeriodModalClose() {
      this.showEventPeriodModal = false;
    },
    /**
     * Handle submit availability request event
     */
    handleSearchOtherServices() {
      this.showRequestSuccessModal = false;
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$v.$reset();
      this.stage = this.$route.meta.stage;
      this.reservation.responsible.ref = getOwner(this.sesion);
      this.reservationCopy = Object.assign({}, this.reservation);
      this.customers = this.customerOptions;
    },
    // <<<<<<<<<<<<<<<<<<<< Customer Methods >>>>>>>>>>>>>>>>>>>>
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().includes(input.trim().toLowerCase()) ||
              customer.company_name.toLowerCase().includes(input.toLowerCase())
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    copyDataCustomer() {
      let totalPassengers = this.reservation.passengers.length;
      if (totalPassengers >= 0 && totalPassengers <= 1) {
        this.reservation.passengers = [
          {
            _id: null,
            reference: uuidv4(),
            firstName: this.customer.first_name,
            lastName: this.customer.last_name,
            fullName: `${this.customer.first_name} ${this.customer.last_name}`,
            email: this.customer.email,
            phone: this.customer.phone,
            gender: this.customer.gender,
            type: "ADULT",
            primary: true,
            notify: this.customer.email ? true : false,
            flightNumber: this.reservation.flight_number
          }
        ];
        this.reservation.pickupSign.format = "CUSTOM";
        this.reservation.pickupSign.text = `${this.getTitleByGender(
          this.customer.gender
        )} ${this.customer.first_name} ${this.customer.last_name}`;
      }
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.customerId = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status && this.customer) {
        this.reservation.customer = this.customer._id;
      }
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (!this.service) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected any available service.`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
          this.customerId = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          let customer = this.customer;
          this.copyData = true;
          if (["travel_access"].includes(customer.type)) {
            this.reservation.customer = customer.owner;
            this.reservation.agent = customer._id;
          } else {
            this.reservation.customer = customer._id;
            this.reservation.agent = null;
          }
          this.calculePriceByCustomer(
            this.reservation.pricing.net_price.last_amount,
            customer.mark_up,
            customer.type_markup
          );
        }
        this.passengers = await this.getPassengersByCustomerId(customerId);
      }
    },
    async checkIfCreditPaymentApplies(customer, pricing, serviceCurrencyCode) {
      const { credit, currency, type } = customer;
      if (credit && credit.status && pricing) {
        if (isPartner(type)) {
          let grossPrice = pricing.totals.gross_price;
          let priceService = await calculateGroosPrice(
            grossPrice,
            serviceCurrencyCode,
            currency.code
          );
          return credit.available >= priceService;
        }
      }
      return false;
    },
    async changePaymentType(value) {
      if (value === "credit") {
        const hasCreditAvailable = await this.checkIfCreditPaymentApplies(
          this.customer,
          this.reservation.pricing,
          this.service.currency.code
        );
        if (!hasCreditAvailable) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Insufficient credit available. Please check the customer's credit balance or select a different payment method.",
            icon: "flaticon-warning-1"
          });
          this.reservation.payment_type = "card";
        }
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Pricing & Adjustments Methods >>>>>>>>>>>>>>>>>>>>
    calculePriceByCustomer(netPrice, markUp, markUpType) {
      let grossPrice =
        markUpType === "markup"
          ? netPrice / (1 - markUp / 100)
          : netPrice * (1 - markUp / 100);

      let totalGrossPrice = calculateTotalPrice(
        parseFloat(grossPrice.toFixed(2)),
        this.reservation.surcharges,
        "gross"
      );
      this.reservation.pricing.gross_price.amount = parseFloat(
        totalGrossPrice.toFixed(2)
      );
      this.reservation.pricing.gross_price.last_amount = this.reservation.pricing.gross_price.amount;

      let netProfit = this.reservation.pricing.gross_price.amount - netPrice;
      this.reservation.pricing.net_profit.amount = parseFloat(
        netProfit.toFixed(2)
      );
      this.reservation.pricing.net_profit.last_amount = this.reservation.pricing.net_profit.amount;

      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
    },
    populatePricing(extras = [], discounts = []) {
      //Calculate Total Extras Net Price
      this.reservation.pricing.totals.extras.net_price = calculateTotalExtrasNetPrice(
        extras
      );
      //Calculate Total Extra Gross Price
      this.reservation.pricing.totals.extras.gross_price = calculateTotalExtraGrossPrice(
        extras
      );
      //Calculate Total Extras Net Profit
      this.reservation.pricing.totals.extras.net_profit =
        this.reservation.pricing.totals.extras.gross_price -
        this.reservation.pricing.totals.extras.net_price;

      //Calculate Total Discounts
      this.reservation.pricing.totals.discounts = calculateTotalDiscounts(
        discounts
      );

      //Calculate Total Net Price
      this.reservation.pricing.totals.net_price = calculateTotalNetPrice([
        this.reservation.pricing.totals.extras.net_price,
        this.reservation.pricing.net_price.last_amount
      ]);

      //Calculate Total Gross Price
      let totalsGrossPrice = calculateTotalGrossPrice([
        this.reservation.pricing.totals.extras.gross_price,
        this.reservation.pricing.gross_price.last_amount
      ]);
      this.reservation.pricing.totals.gross_price =
        totalsGrossPrice - this.reservation.pricing.totals.discounts;

      //Calculate Commissions Platform
      this.reservation.commissions.platform.percentage = getCommissionByCustomer(
        this.customer
      );

      this.reservation.commissions.platform.amount = calculateCommissionAmount(
        this.reservation.pricing.totals.gross_price,
        this.reservation.commissions.platform.percentage
      );

      //Calculate Total Net profit
      this.reservation.pricing.totals.net_profit = calculateTotalNetProfit(
        this.reservation.pricing.totals.gross_price,
        this.reservation.pricing.totals.net_price,
        this.reservation.commissions.platform.amount,
        this.reservation.commissions.payment_processor.amount
      );
    },
    addAdjustments(adjustment) {
      if (adjustment === "extraCharges") {
        this.openExtrasModal(
          this.reservation.service,
          this.reservation.customer
        );
      } else if (adjustment === "discounts") {
        this.openDiscountModal(
          this.reservation.service,
          this.reservation.customer
        );
      } else {
        this.openPriceAdjustments(
          this.reservation.service,
          this.reservation.customer
        );
      }
    },
    openDiscountModal(service, customer) {
      if (service && customer) {
        this.showDiscountModal = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any service and customer.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
    },
    manageDiscounts(discounts = []) {
      this.reservation.pricing.discounts = discounts;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showDiscountModal = false;
    },
    openExtrasModal(service, customer) {
      if (service && customer) {
        this.showExtrasModal = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any service and customer.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
    },
    manageExtras(extras = []) {
      this.reservation.pricing.extras = extras;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showExtrasModal = false;
    },
    openPriceAdjustments() {
      this.lastGrossPrice = this.reservation.pricing.gross_price.last_amount;
      this.lastNetPrice = this.reservation.pricing.net_price.last_amount;
      this.showPriceAdjusments = true;
    },
    closePriceAdjusments() {
      this.lastGrossPrice = 0;
      this.lastNetPrice = 0;
      this.showPriceAdjusments = false;
    },
    managePriceAdjusments(pricing) {
      let { netProfit, grossPrice, netPrice, reason } = pricing;
      this.reservation.pricing.net_price.last_amount = netPrice;
      this.reservation.pricing.gross_price.last_amount = grossPrice;
      this.reservation.pricing.net_profit.last_amount = netProfit;
      this.reservation.pricing.reason_adjustment = reason;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );

      this.showPriceAdjusments = false;
    },
    // <<<<<<<<<<<<<<<<<<<< Passenger Methods >>>>>>>>>>>>>>>>>>>>
    closeNewPassengerModal(status) {
      this.showNewPassengerModal = false;
    },
    closeEditPassengerModal() {
      this.showEditPassengerModal = false;
      this.tempPassenger = null;
      this.passengerIndex = null;
    },
    openEditPassengerModal(passenger, passengerIdentifier) {
      this.showEditPassengerModal = true;
      this.tempPassenger = passenger;
      this.passengerIndex = passengerIdentifier;
    },
    addNewPassenger() {
      if (
        this.reservation.passengers.length < this.reservation.passengersCount
      ) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          this.showNewPassengerModal = true;
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed passengers. Please adjust the number of passengers to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    async removePassenger(index, primary) {
      if (!primary) {
        let { value } = await Swal.fire({
          title: "Remove Passenger",
          html:
            "Are you sure you want to <strong>Remove</strong> the selected Passenger?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          this.reservation.passengers.splice(index, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The PAXhas been removed",
            icon: "flaticon-check-3"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You cannot delete a PAXmarked as primary. To delete this passenger, please assign another PAXas the primary.",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}\nEmail: ${passenger.email}\n`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    makePassengerAsDefault(index) {
      if (index >= 0) {
        this.reservation.passengers = this.reservation.passengers.map(
          passenger => {
            passenger.primary = false;
            return passenger;
          }
        );
        this.reservation.passengers[index].primary = true;
        if (this.reservation.pickupSign.format === "CUSTOM") {
          this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
            this.reservation.passengers
          );
        }
      }
    },
    async addPassenger(passenger) {
      if (passenger) {
        if (this.reservation.passengers.length === 0) {
          passenger.primary = true;
          passenger.notify = passenger.email ? true : false;
          this.reservation.passengers.push(passenger);
          this.reservation.pickupSign.format = "CUSTOM";
          this.reservation.pickupSign.text = `${this.getTitleByGender(
            passenger.gender
          )} ${passenger.firstName} ${passenger.lastName}`;
        } else {
          this.reservation.passengers.push(passenger);
        }
        this.passengers = passenger._id
          ? await this.getPassengersByCustomerId(this.customerId)
          : this.passengers;
      }
    },
    upadtePassenger(passenger) {
      if (passenger) {
        this.reservation.passengers.splice(this.passengerIndex, 1, passenger);
        if (this.reservation.pickupSign.format === "CUSTOM") {
          this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
            this.reservation.passengers
          );
        }
      }
      this.passengerIndex = 0;
      this.tempPassenger = null;
    },
    async getPassengersByCustomerId(customerId) {
      try {
        let { data } = await PassengersAPI.getPassengersByCustomerId(
          customerId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    importPassengers() {
      let passengersCount = this.reservation.passengersCount;
      if (this.reservation.passengers.length < passengersCount) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$refs.fileInput.click();
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed passengers. Please adjust the number of passengers to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    bulkPassengers(event) {
      try {
        const [file] = event.target.files;
        if (file) {
          this.readFile(file);
          this.$refs.fileInput.value = null;
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the import again",
            icon: "flaticon-warning-1"
          });
          this.$refs.fileInput.value = null;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The passengers data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });

        this.$refs.fileInput.value = null;
      }
    },
    readFile(file) {
      try {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: async results => {
            let headers = results.meta.fields;
            let content = parseContentFile(results.data);
            let isValidFile =
              !validateHeadersFile(headers) && validateContentFile(content);
            let passengersCount = this.reservation.passengersCount;
            let diffPassengers =
              passengersCount - this.reservation.passengers.length;
            if (diffPassengers > 0 && content.length <= diffPassengers) {
              if (isValidFile) {
                let localPassengers = getPassengerToRegister(
                  this.reservation.passengers,
                  parsePassengers(content)
                );
                if (this.reservation.passengers.length === 0) {
                  localPassengers[0].primary = true;
                }

                this.reservation.passengers.push(...localPassengers);
                if (this.reservation.pickupSign.format === "CUSTOM") {
                  this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
                    this.reservation.passengers
                  );
                }
                let bulkPassengers = getPassengerToRegister(
                  this.passengers,
                  parsePassengers(content)
                );
                if (bulkPassengers.length) {
                  let registeredPassengers = await this.bulkCreatePassengers(
                    bulkPassengers,
                    this.customer._id,
                    this.customer.type
                  );
                  this.updatePassengerIdentifier(registeredPassengers);
                  this.passengers = await this.getPassengersByCustomerId(
                    this.customerId
                  );
                }
                this.$notify({
                  type: "success",
                  title: "Success!",
                  message: "PAXdata has been imported successfully",
                  icon: "flaticon-check-3"
                });
              } else {
                this.$notify({
                  type: "warning",
                  title: "Warning!",
                  message:
                    "There is an error in the imported file, please check the data and try the import again",
                  icon: "flaticon-warning-1"
                });
              }
            } else {
              this.$notify({
                type: "warning",
                title: "Important!",
                message:
                  "We are sorry, but you have exceeded the maximum number of allowed passengers. Please adjust the number of passengers to proceed.",
                icon: "flaticon-warning-1"
              });
            }
          }
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The passengers data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async bulkCreatePassengers(passengers = [], customerId, customerType) {
      try {
        let { data } = await PassengersAPI.bulkCreatePassengers(
          passengers,
          customerId,
          customerType,
          this.sesion.token
        );
        if (data.status) {
          return data.data.passengers;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    updatePassengerIdentifier(passengers = []) {
      this.reservation.passengers = this.reservation.passengers.map(
        passenger => {
          let element = passengers.find(
            item =>
              item.email === passenger.email && item.phone === passenger.phone
          );
          if (element) {
            passenger._id = element._id;
          }
          return passenger;
        }
      );
    },
    // <<<<<<<<<<<<<<<<<<<< Pickup Sign Methods >>>>>>>>>>>>>>>>>>>>
    async uploadPickupSign(event) {
      this.$refs.pickupSign.click();
    },
    async readPickupSign(event) {
      this.reservation.pickupSign.text = "";
      this.reservation.pickupSign.format = "FILE";
      await this.uploadPickupSignFile(event);
    },
    async uploadPickupSignFile(event) {
      try {
        const [file] = event.target.files;
        if (file && file.type === "application/pdf") {
          if (file.size > 2 * 1024 * 1024) {
            event.preventDefault();
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The file can't be larger than 2MB",
              icon: "flaticon-remove"
            });
            this.clearfile();
          } else {
            this.pdfDataUrl = URL.createObjectURL(file);
            let fileData = FileService.generateResourceData(
              "/uploads/pdf/signs",
              file.name
            );
            let queryString = FileService.buildQueryString(fileData);
            let urlFile = await FileService.uploadResource(file, queryString);
            if (urlFile) {
              this.reservation.pickupSign.link = urlFile;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message:
                  "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
                icon: "flaticon-remove"
              });
            }
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the upload again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The file couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearfile() {
      this.pdfDataUrl = null;
      this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
        this.reservation.passengers
      );
    },
    openPreviewPickup() {
      this.showPreviewPickupSign = true;
    },
    closePreviewPickupSign(status) {
      this.showPreviewPickupSign = status;
      this.pdfDataUrl = null;
    },
    // <<<<<<<<<<<<<<<<<<<< Transfer Type / Reference Methods >>>>>>>>>>>>>>>>>>>>
    changeRouterReference(value) {
      this.routerReference = {
        transferType: this.reservation.type,
        value
      };
    },
    changeReservationTransferType(type) {
      let routerReferenceValue = getRouterReferenceValue(
        type,
        this.routerReference
      );
      if (["arrival", "departure"].includes(type)) {
        this.requestType = "one_way";
        this.reservation.flight_number = routerReferenceValue;
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "station") {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = routerReferenceValue;
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "port") {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = routerReferenceValue;
        this.reservation.number_hourly = 0;
      } else if (type === "hourly") {
        this.requestType = "hourly";
        this.reservation.to = "";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = routerReferenceValue;
      } else {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Flight Methods >>>>>>>>>>>>>>>>>>>>
    async getFlightsInformationByIdent(ident) {
      if (!this.isFlightType || !ident || this.loaderVerifyFlight) return;
      this.loaderVerifyFlight = true;
      try {
        let { data } = await FlightsAPI.getFlightsInformationByIdent(
          ident,
          this.sesion.token
        );
        if (data.status) {
          window.open(
            `https://www.flightaware.com/live/flight/${data.data.ident}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We couldn't display the details of your flight. Please try again later.`,
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We couldn't display the details of your flight. Please try again later.`,
          icon: "flaticon-warning-1"
        });
      }

      this.loaderVerifyFlight = false;
    },
    async handleFlightSelection(payload) {
      const { flight, isAdjustingDateTime, flightType } = payload;
      this.flight = flight;
      this.flight.isAdjustingDateTime = isAdjustingDateTime;
      this.flight.flightType = flightType;
      this.reservation.flight = cloneDeep(flight);
      this.changeRouterReference(this.reservation.flight_number);
      if (isAdjustingDateTime) {
        const date =
          flightType === "ARRIVAL" ? flight.arrivaltime : flight.departuretime;
        const timezone =
          flightType === "ARRIVAL"
            ? flight.destination.timezone
            : flight.origin.timezone;

        this.reservation.pickup_date = getPickupDate(date, timezone);
        if (flightType === "ARRIVAL") {
          this.reservation.pickup_time = getPickupTime(date, timezone);
        }
        this.$notify({
          type: "info",
          title: "Important!",
          message: generateMessageToNotify(flightType),
          icon: "flaticon-notification-bell-outline-interface-symbol"
        });
        await this.requote();
      }
    },
    /**
     * Handle flight validation rules
     * @param {Object} rules - The flight validation rules
     */
    handleValidationState(rules) {
      this.flightValidationRoles = { ...rules };
    },
    /**
     * Reset flight details when flight number input changes
     */
    onFlightNumberInput(flightNumber) {
      if (!flightNumber) {
      }
    },

    /**
     * Handle cutoff modal close event
     */
    // <<<<<<<<<<<<<<<<<<<< Record Loading Methods >>>>>>>>>>>>>>>>>>>>
    async loadReservation(recordId) {
      try {
        const { data } = await ReservationsAPI.getReservation(
          recordId,
          true,
          this.sesion.token
        );
        if (data.status) {
          const reservation = data.data;
          this.reservation.payment_reference = reservation.payment_reference;

          this.reservation.booking_reference = reservation.booking_reference;
          this.reservation.event =
            (reservation.event && reservation.event._id) ||
            reservation.event ||
            null;
          this.requestType =
            reservation.type !== "hourly" ? "one_way" : "hourly";

          /**Address / Date & Time */
          this.reservation.locations.to = reservation.locations.to;

          this.reservation.locations.from = reservation.locations.from;
          this.reservation.distancematrix.distance =
            reservation.distancematrix.distance;
          this.reservation.distancematrix.duration =
            reservation.distancematrix.duration;

          this.reservation.originData = reservation.originData
            ? reservation.originData
            : null;
          this.reservation.destinationData = reservation.destinationData
            ? reservation.destinationData
            : null;
          this.originData = this.reservation.originData;
          this.destinationData = this.reservation.destinationData;
          this.reservation.type = reservation.type;
          this.optionsFrom = populateFromOptions(
            reservation.from,
            this.reservation.type,
            this.originData
          );
          if (reservation.to) {
            this.optionsTo = populateToOptions(
              reservation.to,
              this.reservation.type,
              this.destinationData
            );
          }
          this.reservation.to = reservation.to;
          this.reservation.from = reservation.from;

          this.reservation.passengersCount = reservation.passengersCount;
          this.reservation.childSeatsCount = reservation.childSeatsCount
            ? reservation.childSeatsCount
            : 0;
          this.reservation.flight_number = reservation.flight_number;
          this.reservation.number_stations = reservation.number_stations;
          this.reservation.number_hourly = reservation.number_hourly;
          this.reservation.cruise_line = reservation.cruise_line;
          this.flightType = getFlightType(reservation.type);

          this.routerReference = getRouterReference(
            this.reservation.type,
            this.reservation.flight_number,
            this.reservation.number_stations,
            this.reservation.cruise_line,
            this.reservation.number_hourly
          );

          this.reservation.passenger = reservation.passenger;
          this.initCustomer(reservation.customer, reservation.agent);

          this.reservation.passengers = reservation.passengers;

          /** Price and Fee*/
          this.reservation.pricing.net_price = cloneDeep(
            reservation.pricing.net_price
          );
          this.reservation.pricing.base_price = cloneDeep(
            reservation.pricing.base_price
          );

          this.reservation.pricing.sale_price = cloneDeep(
            reservation.pricing.sale_price
          );

          this.reservation.pricing.gross_price = cloneDeep(
            reservation.pricing.gross_price
          );
          this.reservation.pricing.net_profit = cloneDeep(
            reservation.pricing.net_profit
          );

          this.reservation.pricing.extras = [];
          this.reservation.pricing.discounts = [];

          this.reservation.invoice_number = reservation.invoice_number;
          this.reservation.pickupSign = reservation.pickupSign;
          this.reservation.special_requirements = "";
          this.reservation.payment_type = reservation.payment_type;

          /**Add  Supplier in reservations */
          this.reservation.supplier = reservation.supplier._id;
          this.supplierFilter = reservation.supplier._id;
          this.suppliersOptions.push(reservation.supplier);
          this.supplier = reservation.supplier;

          /**Add branch in reservations */
          this.branchFilter = reservation.branch._id;
          this.branchesAux.push(reservation.branch);
          this.branchesOptions.push(reservation.branch);
          this.reservation.branch = reservation.branch._id;
          this.branch = reservation.branch;

          /**Add service in reservations */

          this.reservation.notificaition = reservation.notificaition;
          this.reservation.service = reservation.service._id;

          let vehicle = reservation.vehicle
            ? reservation.vehicle
            : reservation.service.vehicle;
          this.reservation.vehicle = vehicle._id;

          this.service = populateService(reservation, vehicle);
          if (this.service) {
            this.loaderService = "RESULTS";
          }

          this.populatePricing(
            this.reservation.pricing.extras,
            this.reservation.pricing.discounts
          );
          this.passengers = await this.getPassengersByCustomerId(
            this.customerId
          );
          this.serviceAux.push(this.service);
          this.services.push(this.service);
          this.reservation.surcharges = reservation.surcharges;
          this.reservation.responsible.ref = getOwner(this.sesion);
          this.currency.symbol = this.service.currency.symbol;
          this.currency.code = this.service.currency.code;

          this.$notify({
            type: "info",
            title: "Duplicate reservation!",
            message:
              "Your booking has been duplicated, please remember to change the PickUp Date and PickUp Time.",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    initCustomer(customer, agent) {
      if (customer) {
        if (customer.type === "travel_agency") {
          if (agent) {
            let agentId = getAgentId(agent);
            this.reservation.agent = agentId;
            let ifExist = getCustomerById(this.customers, agentId);
            if (ifExist === undefined) {
              this.customers.push(populateReservationAgent(agent, customer));
            }
            this.customerId = agentId;
          } else {
            let ifExist = getCustomerById(this.customers, customer._id);
            if (ifExist === undefined) {
              this.customers.push(customer);
            }
            this.customerId = customer._id;
          }
        } else {
          let ifExist = getCustomerById(this.customers, customer._id);
          if (ifExist === undefined) {
            this.customers.push(customer);
          }
          this.customerId = customer._id;
        }
        this.reservation.customer = customer._id;
        this.customers = alphabeticallySort(this.customers);
        this.customer = getCustomerById(this.customers, this.customerId);
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Record Saving Methods >>>>>>>>>>>>>>>>>>>>
    async storeReservation(redirectTo) {
      if (this.stage === "QUOTE") {
        await this.validateRecord(redirectTo, this.saveTransferQuote);
        return;
      }

      if (this.requiresAvailabilityConfirmation) {
        this.redirectTo = redirectTo;
        await this.validateRecord(
          this.service,
          this.applyAvailabilityConfirmationState
        );
        return;
      }

      await this.validateRecord(
        {
          redirectTo: redirectTo,
          customer: this.customer,
          creditAvailable: this.creditAvailable
        },
        this.saveReservation
      );
      return;
    },
    async validateRecord(params, callback) {
      if (!this.$v.reservation.$invalid) {
        callback(params);
      } else {
        this.$v.reservation.$touch();
        if (this.$v.reservation.passengersCount.$invalid) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `The number of PAX does not match the number of PAX added to the list.`,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    async saveReservation({ redirectTo = null, customer = null }) {
      const service = this.service;
      let reservation = cloneDeep(this.reservation);
      reservation.notificaition = getConfigTag(customer);
      reservation.pickup_date = buildUtcPickupDateTime(
        reservation.pickup_date,
        reservation.pickup_time
      );

      let hasCreditAvailable = false;
      if (reservation.payment_type === "credit") {
        hasCreditAvailable = await this.checkIfCreditPaymentApplies(
          customer,
          reservation.pricing,
          service.currency.code
        );
        if (!hasCreditAvailable) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Insufficient credit available. Please check the customer's credit balance or select a different payment method.",
            icon: "flaticon-warning-1"
          });
          return;
        }
      }

      const paymentDecision = await this.resolveCreditPayment(
        customer,
        reservation.payment_type,
        hasCreditAvailable
      );

      await this.createdReservation(reservation, {
        isPayConfirmed: paymentDecision
          ? paymentDecision.isPayConfirmed
          : false,
        currencyCode: paymentDecision ? paymentDecision.currencyCode : null,
        paymentMethod: paymentDecision ? PAYMENT_METHOD.CREDIT : null,
        captureMode: paymentDecision ? CAPTURE_MODE_IMMEDIATE : null,
        customerId: paymentDecision ? paymentDecision.customerId : null,
        redirectTo
      });
    },
    async createdReservation(reservation, paymentContext) {
      try {
        this.buttonDisabled = true;
        this.setLoad(true);
        let { data } = await ReservationsAPI.createReservation(
          reservation,
          this.sesion.token
        );
        this.saved = true;

        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }

        if (data.status === "BI") {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Saved",
            icon: "flaticon-check-3"
          });
          return;
        }

        if (paymentContext.isPayConfirmed) {
          paymentContext.ids = [data._id];
          await this.processReservationPayment(data, paymentContext);
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Saved",
          icon: "flaticon-check-3"
        });

        const reservationDetailPath = `/reservations/${data._id}`;
        this.$router.push(
          paymentContext.redirectTo || { path: reservationDetailPath }
        );
        return;
      } catch (error) {
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      } finally {
        this.buttonDisabled = false;
        this.setLoad(false);
      }
    },
    async saveTransferQuote(redirectTo = null) {
      let reservation = cloneDeep(this.reservation);
      reservation.pickup_date = buildUtcPickupDateTime(
        reservation.pickup_date,
        reservation.pickup_time
      );
      reservation.notificaition = getConfigTag(this.customer);

      const confirmationReason = resolveConfirmationReason(
        this.stage,
        this.service
      );
      let transferQuote = mapQuoteFromBooking(reservation, confirmationReason);
      await this.createTransferQuote(transferQuote, redirectTo);
    },
    async createTransferQuote(transferQuote, redirectTo = null) {
      try {
        this.buttonDisabled = true;
        this.setLoad(true);
        let { data } = await QuotesAPI.createQuote(
          transferQuote,
          this.sesion.token
        );
        this.buttonDisabled = false;
        this.setLoad(false);
        this.saved = true;
        if (data) {
          this.transferQuote = data;
          if (this.transferQuote.confirmationReason) {
            this.showRequestSuccessModal = true;
            return;
          }

          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been Saved",
            icon: "flaticon-check-3"
          });
          const redirectPath = this.transferQuote
            ? `/reservations/quote/${this.transferQuote._id}`
            : "/reservations";
          this.$router.push({ path: redirectTo ? redirectTo : redirectPath });
          return;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }
      } catch (error) {
        this.buttonDisabled = false;
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving your quote, please try again"
        );
        return;
      }
    },
    async handleSubmitAvailabilityRequest() {
      this.showCutoffModal = false;
      this.showEventPeriodModal = false;
      await this.validateRecord(this.redirectTo, this.saveTransferQuote);
    },
    /**
     * Redirect to quotes page after successful request submission
     */
    handleViewRequest() {
      this.showRequestSuccessModal = false;
      this.$router.push({
        path: this.transferQuote
          ? `/reservations/quote/${this.transferQuote._id}`
          : "/reservations"
      });
    },
    /**
     * Reset reservation data to search for other services
     */
    // <<<<<<<<<<<<<<<<<<<< Payment Methods >>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    async processReservationPayment(reservation, paymentContext) {
      const {
        currencyCode,
        paymentMethod,
        captureMode,
        customerId,
        ids,
        redirectTo
      } = paymentContext;

      const reservationDetailPath = `/reservations/${reservation._id}`;

      try {
        const payload = this.buildPaymentPayload(
          ids,
          currencyCode,
          paymentMethod,
          captureMode,
          customerId
        );
        const paymentResult = await this.payReservations(payload);

        if (!paymentResult) {
          this.notifyPaymentFailed(paymentContext.redirectTo);
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Saved and Paid",
          icon: "flaticon-check-3"
        });
        this.$router.push(redirectTo || { path: reservationDetailPath });
      } catch (error) {
        this.notifyPaymentFailed(reservationDetailPath);
      }
    },
    notifyPaymentFailed(reservationDetailPath) {
      this.$notify({
        type: "warning",
        title: "Reservation Saved",
        message:
          "The reservation was saved, but the payment could not be processed. Please try paying again from the reservation detail.",
        icon: "flaticon-warning-1"
      });
      this.$router.push({ path: reservationDetailPath });
    },
    buildPaymentPayload(
      ids,
      currencyCode,
      paymentMethod,
      captureMode,
      customerId
    ) {
      return {
        method: paymentMethod,
        customerId: customerId,
        currency: currencyCode,
        captureMode: captureMode,
        ids: ids,
        action: "CREATE"
      };
    },
    async payReservations(payload) {
      try {
        const { data } = await PaymentsAPI.payReservations(
          payload,
          this.sesion.token
        );
        return data || null;
      } catch (error) {
        if (isUnauthorizedError(error)) {
          this.setSigOut(true);
        }
        return null;
      }
    },
    async resolveCreditPayment(customer, paymentType, hasCreditAvailable) {
      if (!customer || !paymentType) return null;

      const { _id: customerId, type: customerType, currency } = customer;
      const isPartnerCustomer = isPartner(customerType);

      if (paymentType === "credit" && hasCreditAvailable && isPartnerCustomer) {
        return {
          isPayConfirmed: true,
          currencyCode: currency.code,
          customerId: customerId
        };
      }
      return null;
    },
    // <<<<<<<<<<<<<<<<<<<< Vuex Bindings >>>>>>>>>>>>>>>>>>>>
    ...mapActions(["getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread"
    ])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let notChanged = isEqual(this.reservation, this.reservationCopy);
      if (!notChanged && !this.saved && this.canUserCreate) {
        Swal.fire({
          title: "Important",
          html:
            "The Reservation has been modified,<br> do you want to <strong>save changes</strong>?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.storeReservation(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
  validations: {
    contactNumber: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(18)
    },
    phone_format: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(18)
    },
    reservation: {
      from: {
        required
      },
      to: {
        required: requiredIf(function(value) {
          return this.reservation.type !== "hourly";
        }),
        differentFromPickup: function(value) {
          if (this.reservation.type === "hourly") return true;
          return value !== this.reservation.from;
        }
      },
      pickup_date: {
        required
      },
      pickup_time: {
        required
      },
      passengersCount: {
        required,
        numeric,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(85),
        customValidator: function(value) {
          return this.reservation.passengers.length <= value;
        }
      },
      customer: {
        required,
        alphaNum
      },
      service: {
        required
      },
      number_hourly: {
        required: requiredIf(function() {
          return this.reservation.type === "hourly";
        }),
        minValue: function(value) {
          if (this.reservation.type !== "hourly") return () => true;
          return value > 1;
        }
      },
      number_stations: {
        maxLength: maxLength(45)
      },
      cruise_line: {
        maxLength: maxLength(45)
      },
      flight_number: {
        required: requiredIf(function(value) {
          return false;
        }),
        isFlightValid(value) {
          if (["arrival", "departure"].includes(this.reservation.type)) {
            if (!value) return true;
            const regex = /^[A-Z0-9]{1,3}?\d{1,5}[A-Z]?$/i;
            return regex.test(value.trim());
          }
          return true;
        },
        isValidate(value) {
          if (["arrival", "departure"].includes(this.reservation.type)) {
            let flightType = this.flightValidationRoles.flightType;
            if (["ARRIVAL", "DEPARTURE"].includes(flightType)) {
              return this.flightValidationRoles.isValidateFlightNumber;
            }
          }
          return true;
        }
      },
      deal_number: {
        maxLength: maxLength(10),
        customValidator: function(value) {
          if (value) {
            const regex = /^[A-Za-z]{3}-\d{5,6}$/;
            return regex.test(value);
          }
          return true;
        }
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      pricing: {
        net_price: {
          last_amount: {
            required,
            decimal,
            minValue: minValue(1)
          }
        },
        gross_price: {
          last_amount: {
            required,
            decimal,
            minValue: minValue(1)
          }
        }
      },
      childSeatsCount: {
        numeric,
        integer,
        maxValue: maxValue(10)
      }
    }
  },
  components: {
    TransportReference,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    VueTelInput,
    WSelect: WSelect,
    AddCustomer,
    NewPassenger,
    EditPassenger,
    Services,
    FadeTransition,
    Charges,
    ManageExtraCharges,
    ManageDiscounts,
    ManagePriceAdjustments,
    FlightNumberInput,
    FlightDetails,
    CutoffTimeConfirmationModal,
    EventPeriodAvailabilityModal,
    AvailabilityRequestSuccessModal
  },
  computed: {
    isFlightType() {
      return ["airport", "arrival", "departure"].includes(
        this.reservation.type
      );
    },
    ...mapGetters([
      "locations",
      "customerOptions",
      "sesion",
      "userRole",
      "load",
      "sigout"
    ]),
    canUserCreate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CREATE");
    },
    passenger() {
      const passengers = this.reservation.passengers;
      let passenger = passengers.find(p => p.primary === true) || passengers[0];
      return {
        gender: passenger ? passenger.gender : "",
        fullName: passenger ? passenger.fullName : "",
        email: passenger ? passenger.email : "",
        phone: passenger ? passenger.phone : ""
      };
    }
  }
};
</script>
